import { render, staticRenderFns } from "./VideoModalPage.vue?vue&type=template&id=0c9e5611&"
import script from "./VideoModalPage.vue?vue&type=script&lang=ts&"
export * from "./VideoModalPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports